<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="提示列表" prop="tipList">
          <el-button type="primary" size="mini" @click="handleAddTip">新增</el-button>
          <el-table :data="form.tipList" stripe>
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column label="图标">
              <template #default="{ row }">
                <img :src="row.icon" class="avatar icon_avatar" />
              </template>
            </el-table-column>
            <el-table-column label="描述">
              <template #default="{ row }">
                {{ row.text }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              width="150"
            >
              <template #default="{ row, $index }">
                <el-button type="primary" @click="handleEditTip(row, $index)">编辑</el-button>
                <el-button type="error" @click="handleDelTip($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="tipVisible"
      :close-on-click-modal="false"
      :title="tipTitle"
      width="70%"
    >
      <el-form ref="tip" :model="tip" label-width="120px">
        <el-form-item label="图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="tip.icon" :src="tip.icon" class="avatar" >
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="项目列表">
          <el-input v-model="tip.text" placeholder="描述"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="tipVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTip">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createFaq, editFaq } from '@/api/ticket'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'SpotTagEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken:null,
      form: {
        faqId:'',
        title: '',
        tipList: [],
        order: 0,
      },
      tip: {
        icon: '',
        text: '',
      },
      tipVisible: false,
      tipTitle: '新增提示',
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      },
      dialogFormVisible: false
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改常见问题'
        this.form = Object.assign(this.form, row.basic)
        this.form.faqId = row.faqId
        this.form.title = row.title
      } else {
        this.title = '新增常见问题'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    handleAddTip() {
      this.tip = {
        icon: '',
        text: ''
      }
      this.tipTitle = '新增提示'
      this.tipVisible = true
    },
    handleEditTip(row, index) {
      this.tip = {
        ...row,
        index
      }
      this.tipTitle = '编辑提示'
      this.tipVisible = true
    },
    handleDelTip(index) {
      this.form.tipList.splice(index, 1)
    },
    addTip() {
      const { index, icon, text } = this.tip
      if (index !== undefined) {
        this.form.tipList.splice(index, 1, {
          icon,
          text
        })
      } else {
        this.form.tipList.push(this.tip)
      }
      this.tipVisible = false
    },
    // 图片
    image_remove(file, fileList) {
      this.tip.icon = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.tip.icon = `${QNHost}/${res.hash}`
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const tagId = this.form.tagId
          const data = Object.assign({},this.form)
          this.$baseConfirm(
            `你确定要${tagId ? '修改' : '新增'}问题吗`,
            null,
            async () => {
              tagId
                ? await editFaq(data)
                : await createFaq(data)
              this.$baseMessage(
                `${tagId ? '修改' : '新增'}问题成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all .3s ease-in-out;
    @include size;
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
</style>
